import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetRequestsList = () => 
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}DataManagement/GetRequestsList`
	});

export const DeleteRequest = (userId, name) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataManagement/DeleteRequest`,
		data: { name, userId },
	});

export const UpdateRequest = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataManagement/Update`,
		data: dto,
	});

export const CreateXMLTopologyRequest = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataManagement/CreateXMLTopology`,
		data: dto,
	});

export const CreateS12ThresholdsRequest = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataManagement/CreateS12Thresholds`,
		data: dto,
	});

export const VTKDataRefreshRequest = (dto, onUploadProgress) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataManagement/ImportS12ByUser`,
		data: dto,
		onUploadProgress: (event) => {
			if (onUploadProgress && event.lengthComputable) {
				const percent = Math.round((event.loaded / event.total) * 100);
				onUploadProgress(percent);
			}
		},
	});

export const VTKDataRefreshEmailRequest = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataManagement/ImportS12KpisFromEmail`,
		data: dto,
	});

export const VTKDataRefreshOneDriveRequest = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataManagement/ImportS12KpisFromOneDrive`,
		data: dto,
	});

export const TrafficTrendsDataRefreshRequest = (dto, onUploadProgress) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}DataManagement/ImportTrafficTrendsByUser`,
		data: dto,
		onUploadProgress: (event) => {
			if (onUploadProgress && event.lengthComputable) {
				const percent = Math.round((event.loaded / event.total) * 100);
				onUploadProgress(percent);
			}
		},
	});